import { WatchQueryFetchPolicy } from 'apollo-client';
import gql from 'graphql-tag';
import { useQuery } from 'react-apollo';

export const useTrustBalanceByAgeQuery = (params: TrustBalanceByAgeParams, fetchPolicy?: WatchQueryFetchPolicy) => {
    const documentQuery = useQuery<TrustBalanceByAgeData, TrustBalanceByAgeParams>(TrustBalanceByAgeQuery, {
        fetchPolicy: fetchPolicy,
        variables: {
            ...params,
        },
    });

    return { ...documentQuery };
};

export interface TrustBalanceByAgeParams {
    entityType?: number;
    entityGuid?: string;
    responsibility?: number;
}

export type TrustBalanceByAgeData = {
  statistics: Statistics;
};

export type Statistics = {
  matter: Matter;
};

export type Matter = {
  trustBalancesByAge: TrustBalancesByAge;
};

export type TrustBalancesByAge = {
  balances: Balance[];
  total:    number;
};

export type Balance = {
  matters:  number;
  balance:  number;
  format:   string;
  grouping: string;
};

export const TrustBalanceByAgeQuery = gql`
    query TrustBalancesByAge($entityType: Int, $entityGuid: String, $responsibility: Int) {
        statistics {
            matter {
                trustBalancesByAge(entityType: $entityType, entityGuid: $entityGuid, responsibility: $responsibility) {
                    balances {
                        matters
                        balance
                        format
                        grouping
                    }
                    total
                }
            }
        }
    }
`;